import React, { useState, useEffect } from "react";
import axios from "axios";
import { AreaChart, Area, Tooltip, ResponsiveContainer, XAxis } from "recharts";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import moment from "moment";

const Chart = ({ address, txHistory, tokens }) => {
  const [chartData, setChartData] = useState(null);
  const [transformedData, setTransformedData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (txHistory?.length > 100) {
      console.log("You need to upgrade your plan to fetch your transactions!");
    } else if (tokens?.length === 0) {
      console.log("");
    } else {
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `https://chainpulseserver.onrender.com/api/wallet/history/${address}`,
            {
              headers: {
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_API_KEY,
              },
            }
          );

          setChartData(response?.data?.data);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [address, txHistory, tokens]);

  useEffect(() => {
    if (chartData && chartData.balance_history) {
      const transformedData = chartData.balance_history.map(
        ([timestamp, value]) => {
          const formattedDate = moment(timestamp).format("lll");

          return {
            date: formattedDate,
            totalLiquidityUSD: value,
          };
        }
      );
      setTransformedData(transformedData);
    }
  }, [chartData]);

  function getGradientColor() {
    if (transformedData.length === 0) return "#8884d8"; // Default color

    const initialValue = transformedData[0].totalLiquidityUSD;
    const finalValue =
      transformedData[transformedData.length - 1].totalLiquidityUSD;

    return finalValue > initialValue ? "#0db68c" : "#cd4976";
  }

  function CustomTooltip({ payload, label, active }) {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <Box>{label}</Box> {/* Use formatted label directly */}
          <Box>
            $
            {payload[0].value.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </div>
      );
    }
    return null;
  }

  return (
    <div>
      <Flex
        mt="10px"
        flexDir="column"
        w="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box border="1px solid #292929" borderRadius="10px" w="100%" p="15px">
          <Box fontSize="20px">Historical Performance</Box>
          {loading ? ( // Render loading indicator if loading is true
            <Flex
              mt="10px"
              justifyContent="center"
              alignItems="center"
              height={300}
            >
              <Spinner />
            </Flex>
          ) : (
            <>
              {transformedData.length !== 0 && (
                <ResponsiveContainer width="100%" height={300}>
                  <AreaChart
                    data={transformedData}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    {/* Linear gradient definitions */}
                    <XAxis dataKey="date" hide axisLine={false} />{" "}
                    {/* Specify the x-axis dataKey as "date" */}
                    <Tooltip content={<CustomTooltip />} />
                    <Area
                      type="monotone"
                      dataKey="totalLiquidityUSD"
                      stroke={getGradientColor()}
                      fillOpacity={1}
                      fill="url(#colorGradient)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              )}
            </>
          )}
        </Box>
      </Flex>
    </div>
  );
};

export default Chart;
